<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ 'bikeshop.shop_setup.card_headers.paystack_deposits' | translate }}
</span>
    </div>
  </div>

  <div class="content">
    <div class="sub-header margin-top-16">
      {{"bikeshop.shop_setup.card_description.paystack_deposits" | translate}}
    </div>

    <div>
      <div *ngIf="busy" style="display: block;margin-top:16px">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                           animationDuration=".5s">
        </p-progressSpinner>
      </div>
      <div *ngIf="!linkedToPaystack && !busy">
        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ "bikeshop.shop_profile.paystack.paystack_secret_key" | translate }}
          </div>
          <div class="col-md-4">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="fa fa-key"></i></span>
              <input type="text" pInputText [(ngModel)]="paystackSecretKey"
                     placeholder="{{ 'bikeshop.shop_profile.paystack.paystack_secret_key' | translate }}"/>
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-12 label">
            <div innerHTML="{{ (isRentals ? 'bikeshop.shop_profile.paystack.paystack_secret_key_message' : 'bikeshop.shop_profile.paystack.workshop_paystack_secret_key_message') | translate}}"></div>
          </div>
        </div>
        <div class="row margin-top-16">
          <div class="col-md-5"></div>
          <div class="col-md-3">
            <button pButton class="p-button-raised full-width" label="{{
              'bikeshop.shop_profile.paystack.connect_paystack' | translate
            }}" (click)="linkPaystackAccount()" [disabled]="!paystackSecretKey || busy"></button>
          </div>
        </div>
      </div>
      <div *ngIf="linkedToPaystack && !busy">
        <div class="row margin-top-16">
          <div class="col-md-12 label">
            {{ (isRentals ? "bikeshop.shop_profile.paystack.connected_message" : "bikeshop.shop_profile.paystack.workshop_connected_message" ) | translate }}
          </div>
        </div>
        <div class="row margin-top-16">
          <div class="col-md-3" style="margin-top:auto;margin-bottom:auto;">
            <button pButton type="submit" class="p-button-raised full-width"
                    label="{{ 'bikeshop.shop_profile.paystack.disconnect_from_paystack' | translate }}"
                    (click)="disconnectPaystackAccount()" [disabled]="busy"></button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="powered_by_paystack">
            <img src="../../../../../../../assets/paystack.png">
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
